import React, { useRef, useState } from 'react';
import { X, Download, Loader2 } from 'lucide-react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import BudgetTemplate from './BudgetTemplate';

const PdfPreviewModal = ({ budget, onClose }) => {
  const printRef = useRef(null);
  const [generating, setGenerating] = useState(false);

  const handleGeneratePdf = async () => {
    if (!printRef.current) return;
    setGenerating(true);
    try {
      const element = printRef.current;
      const canvas = await html2canvas(element, {
        scale: 3,
        useCORS: true,
        logging: false,
        backgroundColor: '#f6f6f6',
        windowWidth: element.offsetWidth,
        windowHeight: element.offsetHeight
      });
      const imgData = canvas.toDataURL('image/png');

      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4'
      });
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const ratio = canvas.width / canvas.height;
      const totalPdfHeight = pdfWidth / ratio;
      let position = 0;
      let heightLeft = totalPdfHeight;

      pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, totalPdfHeight);
      heightLeft -= pdfHeight;

      while (heightLeft > 0) {
        position = heightLeft - totalPdfHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, totalPdfHeight);
        heightLeft -= pdfHeight;
      }

      const fileName = `orcamento-${Date.now()}.pdf`;
      pdf.save(fileName);
    } catch (error) {
      console.error('Erro ao gerar PDF:', error);
      alert('Erro ao gerar PDF: ' + error.message);
    } finally {
      setGenerating(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{ background: 'rgba(0,0,0,0.6)' }}
    >
      <div
        className="relative bg-white rounded-xl shadow-2xl overflow-hidden"
        style={{ width: '940px', maxWidth: '95vw', maxHeight: '95vh', display: 'flex', flexDirection: 'column' }}
      >
        <div
          className="flex items-center justify-between px-6 py-4 border-b border-gray-200"
          style={{ background: 'linear-gradient(135deg, #48984f, #3d7d43)', color: 'white', flexShrink: 0 }}
        >
          <h2 className="text-lg font-bold">Prévia do Orçamento — PDF Premium</h2>
          <div className="flex items-center gap-3">
            <button
              onClick={handleGeneratePdf}
              disabled={generating}
              className="flex items-center gap-2 px-4 py-2 bg-white text-[#48984f] rounded-lg font-semibold text-sm hover:bg-emerald-50 disabled:opacity-60"
            >
              {generating ? (
                <>
                  <Loader2 size={16} className="animate-spin" />
                  Gerando...
                </>
              ) : (
                <>
                  <Download size={16} />
                  Baixar PDF
                </>
              )}
            </button>
            <button
              onClick={onClose}
              className="p-1 hover:bg-emerald-700 rounded"
            >
              <X size={20} />
            </button>
          </div>
        </div>

        <div
          className="flex-1 overflow-auto p-4"
          style={{ background: '#d1d5db', display: 'flex', justifyContent: 'center' }}
        >
          <div style={{ display: 'inline-block', minWidth: '210mm' }}>
            <div ref={printRef}>
              <BudgetTemplate budget={budget} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PdfPreviewModal;
